import React from 'react'
import { InnerPageBase } from '../../../../../white-label/src/main/pages/defaults/InnerPage'
import { useRouteFlagMenuFilter } from '../../../../../../shared/src/smartNav/useRouteFlagMenuFilter'

// White-label layout + menu, hiding the meeting-room items while their route flag is OFF.
export const InnerPage = (): React.JSX.Element => {
  const filterMenuItems = useRouteFlagMenuFilter()
  return <InnerPageBase filterMenuItems={filterMenuItems} />
}
